import { FlexBox, Switch, Text } from '@dixa/lib-shared-habla';
import cx from 'classnames';

import styles from './toggleBox.module.scss';

export type ToggleBoxProps = {
  onChange: (value: boolean) => void;
  name: string;
  value: boolean;
  heading: string;
  subHeading?: string;
  /** For wrapping element */
  className?: string;
  dark?: boolean;
  padding?: string;
  disabled?: boolean;
};
/**
 * This component should move into Habla, it's needed and only present in Fable
 * currently
 */
export function ToggleBox({
  name,
  onChange,
  value,
  heading,
  subHeading,
  className,
  dark = false,
  padding,
  disabled,
}: ToggleBoxProps): JSX.Element {
  return (
    <FlexBox
      justifyContent="flex-start"
      alignItems="center"
      className={cx(styles.wrapper, className, {
        [styles.wrapperDark]: dark,
      })}
      gap="300"
    >
      <Switch
        name={name}
        id={name}
        title={heading}
        onChange={(e) =>
          onChange(e.currentTarget.value === 'true' ? false : true)
        }
        value={value.toString()}
        checked={value}
        disabled={disabled}
      />
      <FlexBox
        flexDirection="column"
        style={{
          padding: padding || `300 0`,
        }}
      >
        <Text.Paragraph
          variant="1"
          className={cx({ [styles.marginBottom]: !!subHeading })}
        >
          {heading}
        </Text.Paragraph>
        {!!subHeading && (
          <Text.Paragraph variant="4" subdued>
            {subHeading}
          </Text.Paragraph>
        )}
      </FlexBox>
    </FlexBox>
  );
}
